import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { store } from './state/store';
import { APIProvider } from '@vis.gl/react-google-maps';

// Suppress ResizeObserver loop warning (harmless, caused by rsuite components)
// Method 1: Override console.error
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string') {
    if (
      args[0].includes('ResizeObserver loop limit exceeded') ||
      args[0].includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      return;
    }
  }
  originalError.apply(console, args);
};

// Method 2: Add window error handler for ResizeObserver
window.addEventListener('error', (e) => {
  if (e.message.includes('ResizeObserver loop') ||
    e.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let persistor = persistStore(store);


switch (document.location.hostname) {
  case "localhost":
    document.title = 'Easyride(Dev)';
    break;
  case "www.ridego.me":
    document.title = 'Ride Go 機場接送';
    break;

  default:
    break;
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>

      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <APIProvider apiKey={API_KEY!}
            solutionChannel='GMP_devsite_samples_v3_rgmautocomplete'>
            <App />
          </APIProvider>
        </PersistGate>
      </Provider>

    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
